// *******************************************************************************
// Mod Image
// *******************************************************************************

const modImage = document.querySelectorAll('.mod-image');

if (modImage.length > 0) {
  let modImageEle = null;
  const mm = gsap.matchMedia();

  const initModImageScrollMagic = () => {
    modImageEle = new ScrollMagic.Controller();

    modImage.forEach((ele) => {
      const stickyElem = ele.querySelector('.mod-image__sticky');
      const imageElem = ele.querySelector('.mod-image__init');

      const imageTween = gsap.to(imageElem, {
        width: windowWidth() > breakpointLg ? 'calc(100vw - 24px)' : 'calc(100vw - 12px)',
        height: '100vh',
        borderRadius: 18,
        // markers: true,
      });

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: stickyElem.clientHeight,
        triggerHook: 0.3,
      })
        // .addIndicators({ name: 'Image' })
        .setTween(imageTween)
        .addTo(modImageEle);
    });
  };

  mm.add('(min-width: 1023px)', () => {
    initModImageScrollMagic();
  });
}
